module.exports = __webpack_public_path__ + "images/dan_furfari.jpg?v=d404bf2032b59c9dfe01f4b9524da184";